import React, { useEffect } from 'react'
import { ThemeProvider, Global as EmotionGlobal, Theme } from '@emotion/react'
import { globalLinuxPrintStyle } from './style'
import { useAppDispatch, useAppSelector } from './redux/hooks'
import { Outlet, useParams } from 'react-router'
import { fusionPrintThemeOverrides } from '@fusion-advantage/formrender'
import { RootRouteContentType, WorkItemAction } from '@fusion-advantage/formlib'
import { adhocViewEncounter } from './redux/syncthunk/adhocViewEncounterThunk'
import { SyncType } from './redux/syncthunk/SyncConfig'

export const PrintRouteParams = {
	token: 'token',
	encounterGuid: 'encounterGuid',
	pageIdx: 'pageIdx',
} as const

export const PrintRoute = React.memo(props => {
	const booted = useAppSelector(state => state.app.booted)
	const content = useAppSelector(state => state.app.content)
	const dispatch = useAppDispatch()
	const routeParams = useParams()
	const token = routeParams[PrintRouteParams.token]
	const encounterGuid = routeParams[PrintRouteParams.encounterGuid]
	const pageIdxParam = routeParams[PrintRouteParams.pageIdx]
	let pageIdx: number|undefined = undefined
	if(pageIdxParam) {
		pageIdx = Number(pageIdxParam)
		if(isNaN(pageIdx)) {
			pageIdx = undefined
		}
	}
	useEffect(() => {
		(async function() {
			if(!token || !encounterGuid || !booted) {
				return
			}
			dispatch(adhocViewEncounter({
				syncType: SyncType.Boot,
				encounterGuid,
				action: WorkItemAction.ViewFormAsDocgen,
				onlyPageIdx: pageIdx,
			}))
		})()
	}, [token, encounterGuid, pageIdx, booted])
	if(!token) {
		return <h2>Token is not available</h2>
	}
	if(!encounterGuid) {
		return <h2>Encounter GUID is not available</h2>
	}
	if(pageIdxParam && pageIdx === undefined) {
		return <h2>Invalid pageIdx specified</h2>
	}
	if(!booted) {
		return <>
			<h2>Booting...</h2>
		</>
	}
	if(content.type !== RootRouteContentType.Form) {
		return <>
			<h2>Setting content...</h2>
		</>
	}
	return (
		<ThemeProvider theme={fusionPrintThemeOverrides}>
			<EmotionGlobal styles={globalLinuxPrintStyle} />
			<Outlet />
		</ThemeProvider>
	)
})
